var React = require('react');

function DirectToDeveloper (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.1667 0H3.83333C2.53833 0 1.5 1.04944 1.5 2.33208V18.6566C1.5 19.9393 2.55 20.9887 3.83333 20.9887H8.5L11.1717 23.6589C11.6267 24.1137 12.3617 24.1137 12.8167 23.6589L15.5 20.9887H20.1667C21.45 20.9887 22.5 19.9393 22.5 18.6566V2.33208C22.5 1.04944 21.45 0 20.1667 0ZM12 3.84793C13.7383 3.84793 15.15 5.25884 15.15 6.99623C15.15 8.73363 13.7383 10.1445 12 10.1445C10.2617 10.1445 8.85 8.73363 8.85 6.99623C8.85 5.25884 10.2617 3.84793 12 3.84793ZM19 16.3245H5V15.2751C5 12.943 9.66667 11.6604 12 11.6604C14.3333 11.6604 19 12.943 19 15.2751V16.3245Z"}));
}

DirectToDeveloper.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DirectToDeveloper;

DirectToDeveloper.default = DirectToDeveloper;
